var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._g(_vm._b({staticStyle:{"width":"100%"},attrs:{"clearable":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'el-select',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.items),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.classRoomNo,"value":item.classRoomNo}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }